import { BusinessInsightsContextValue } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/businessInsightsContext';

export const defaultBusinessInsightsContextValue: BusinessInsightsContextValue =
  {
    authorizationKey: undefined,
    authorizationToken: undefined,
    dashboardId: undefined,
    uniqueName: undefined,
    displayName: undefined,
    enabled: true,
    dataLastUpdated: undefined,
    filterDetails: [],
    isLoading: false,
    isError: false,
  };
